import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from './api.service';
import { DeviceResponseDto } from '@qc/shared/dto';

@Injectable({ providedIn: 'root' })
export class DeviceService extends ApiService {
    protected get basePath(): string {
        return '/auth/devices';
    }

    getUserDevices() {
        return this.getPaginated<DeviceResponseDto>('');
    }

    removeDevice(deviceId: string): Observable<void> {
        return this.deleteVoid(deviceId);
    }
}
